import {
  allRequest,
  getRequest,
  postRequest,
  REQUEST_METHOD_GET
} from '../../../middlewares/api/actions';
import {
  getCubeUrl,
  getDcsUrl,
  getAttributeFileUrl,
  getUploadFileOnServerUrl
} from '../../../constants/urls';

export const IMPORT_ATTRIBUTE_CHANGE = 'IMPORT_ATTRIBUTE_CHANGE';
export const IMPORT_ATTRIBUTE_CUBE_TREE_SHOW = 'IMPORT_ATTRIBUTE_CUBE_TREE_SHOW';
export const IMPORT_ATTRIBUTE_CUBE_TREE_HIDE = 'IMPORT_ATTRIBUTE_CUBE_TREE_HIDE';
export const IMPORT_ATTRIBUTE_CUBE_SET = 'IMPORT_ATTRIBUTE_CUBE_SET';
export const IMPORT_ATTRIBUTE_CUBE_UNSET = 'IMPORT_ATTRIBUTE_CUBE_UNSET';
export const IMPORT_ATTRIBUTE_CUBE_READ = 'IMPORT_ATTRIBUTE_CUBE_READ';
export const IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ = 'IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ';
export const IMPORT_ATTRIBUTE_FILE_UPLOAD = 'IMPORT_ATTRIBUTE_FILE_UPLOAD';
export const IMPORT_ATTRIBUTE_SUBMIT = 'IMPORT_ATTRIBUTE_SUBMIT';
export const IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE = 'IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE';

export const changeAttributeFile = fields => ({
  type: IMPORT_ATTRIBUTE_CHANGE,
  fields
});

export const showAttributeFileCubeTree = () => ({
  type: IMPORT_ATTRIBUTE_CUBE_TREE_SHOW
});

export const hideAttributeFileCubeTree = () => ({
  type: IMPORT_ATTRIBUTE_CUBE_TREE_HIDE
});

export const setAttributeFileCube = cubeId => ({
  type: IMPORT_ATTRIBUTE_CUBE_SET,
  cubeId
});

export const unsetAttributeFileCube = () => ({
  type: IMPORT_ATTRIBUTE_CUBE_UNSET
});

export const readAttributeFileCube = cubeId => getRequest(
  IMPORT_ATTRIBUTE_CUBE_READ,
  getCubeUrl(cubeId)
);

export const readAttributeFileCategorisedCubes = () =>
  allRequest(
    IMPORT_ATTRIBUTE_CATEGORISED_CUBES_READ,
    [REQUEST_METHOD_GET, REQUEST_METHOD_GET],
    [getCubeUrl(), getDcsUrl()]
  );

export const uploadAttributeFileFile = (file, cubeId) => {
  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return postRequest(
    IMPORT_ATTRIBUTE_FILE_UPLOAD,
    getUploadFileOnServerUrl(cubeId),
    fileFormData,
    t => ({
      start: t('scenes.dataManager.attributeFile.messages.fileUpload.start'),
      success: t('scenes.dataManager.attributeFile.messages.fileUpload.success')
    })
  );
};

export const submitAttributeFile = (separator, delimiter, cubeId, filePath, tid, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload) => getRequest(
  IMPORT_ATTRIBUTE_SUBMIT,
  getAttributeFileUrl(separator, delimiter, true, cubeId, filePath, tid, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload),
  t => ({
    start: t('scenes.dataManager.attributeFile.messages.submit.start'),
    success: t('scenes.dataManager.attributeFile.messages.submit.success')
  })
);

export const onHideAttributeFileIgnoreConcurrentUploadConfirm = () => ({
  type: IMPORT_ATTRIBUTE_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE
});


// WEBPACK FOOTER //
// ./src/scenes/data-manager/attribute-file/actions.js